import { render, staticRenderFns } from "./Whatispinpos.vue?vue&type=template&id=f1d3d102&scoped=true"
import script from "./Whatispinpos.vue?vue&type=script&lang=js"
export * from "./Whatispinpos.vue?vue&type=script&lang=js"
import style0 from "./Whatispinpos.vue?vue&type=style&index=0&id=f1d3d102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d3d102",
  null
  
)

export default component.exports